export default "__VITE_ASSET__CwuDh2wJ__"